import messages from './messages';
import { StateProgramSetup } from '../StateProgramSetup';
import PropertyStateConfig from '../../../PropertyStateConfig';

const VHCBSetup = ({
  editMode,
  onChange,
  values,
  promptToaster,
  isLoadingPassbookRateData,
  state,
  stateConfigs,
}: Props) => {
  const vhcbConfig = {
    programName: 'VHCB',
    titleMessage: messages.title,
    showInterimCerts: true,
    showOverrideQualification: true,
    showAnnualRecertMonth: true,
  };

  return (
    <>
      <StateProgramSetup
        editMode={editMode}
        onChange={onChange}
        values={values}
        promptToaster={promptToaster}
        isLoadingPassbookRateData={isLoadingPassbookRateData}
        config={vhcbConfig}
      />

      <PropertyStateConfig
        editMode={editMode}
        onChange={onChange}
        state={state}
        stateConfigs={stateConfigs}
        affordableProgramName={vhcbConfig.programName}
      />
    </>
  );
};

export default VHCBSetup;
